export class bookingFlowDataLayer {
    constructor() {

        this.events = {
            findLagerFlow: 'find_lager_flow',
            findRumFlow:'find_rum_flow',
            findPrisFlow:'find_pris_flow',
            otherFlow:'other_flow',
            hasSeenNoAvailableRoomsMessage:'hasSeenNoAvailableRoomsMessage',
        }

        this.steps = {
            atOrigin: 'start',
            begin: 'til afdeling',
            roomAdded: 'tilføjet rum',
            customerNew: 'ny kunde',
            customerExisting: 'eksisterende kunde',
            accept: 'bekræft lejeaftale',
            leaseCreated: 'lejeaftale oprettet',
            payment: 'betaling',
            paySuccessAlarmOn: 'betaling lykkes, alarm til',
            paySuccessAlarmOff: 'betaling lykkes, alarm fra',
            payFailAlarmOn: 'betaling fejlede, alarm til',
            payFailAlarmOff: 'betaling fejlede, alarm fra'
        }

        this.getEventName = function (uri) {
            if(uri) {
                if(uri.includes('.dk')) {
                    uri = uri.split('.dk')[1];
                }
                if(uri.includes('?')) {
                    uri = uri.split('?',1)[0];
                }
    
                if (uri.includes('/lagerhoteller/')) {
                    return this.events.findLagerFlow;
                }
    
                if (uri.includes('/find-rumstorrelse/')) {
                    return this.events.findRumFlow;
                }
    
                if (uri.includes('/find-pris/')) {
                    return this.events.findPrisFlow;
                }
            }
            return this.events.otherFlow;
        }

        

        this.pushToDataLayer = function (event, step,rooms = []) {
            if (event) {
                window.dataLayer.push({
                    'event': event,
                    'step': step,
                    'rooms':rooms
                });
            }
        }

        this.getRoomListFromBasket = function (basket,department) {
            return basket.map(x => ({
                size: x.room.Size + " m2",
                place: `${department.City}, ${department.Address}`,
                price: x.room.PriceNumeric
            }));
        }
    }
};
export default new bookingFlowDataLayer();